import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyScale'
})
export class CurrencyScalePipe implements PipeTransform {

  transform(value: number | null | undefined): string {
    if (value == null) return 'R$ 0';

    if (value >= 1_000_000_000) {
      return `R$ ${(value / 1_000_000_000).toFixed(1).replace('.', ',')} Bi`;
    }

    if (value >= 1_000_000) {
      return `R$ ${(value / 1_000_000).toFixed(1).replace('.', ',')} Mi`;
    }

    if (value >= 1_000) {
      return `R$ ${(value / 1_000).toFixed(1).replace('.', ',')} mil`;
    }

    return `R$ ${value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  }
}
